// Substituted at build (webpack/Vite define) or bundle deploy time.
declare global {
  var DATADOG_APPLICATION_ID: string | undefined;
  var DATADOG_CLIENT_TOKEN: string | undefined;
  var REDO_API_URL: string | undefined;
  var REDO_MARKETPLACE_APP_VERSION: string | undefined;
  var REDO_MARKETPLACE_SERVER_URL: string | undefined;
}

export const REDO_API_URL = globalThis.REDO_API_URL || "http://localhost:8888";

export const REDO_MARKETPLACE_APP_VERSION =
  globalThis.REDO_MARKETPLACE_APP_VERSION || "_";

export const REDO_MARKETPLACE_SERVER_URL =
  globalThis.REDO_MARKETPLACE_SERVER_URL || "http://localhost:8018";

export const DATADOG_APPLICATION_ID = globalThis.DATADOG_APPLICATION_ID ?? null;
export const DATADOG_CLIENT_TOKEN = globalThis.DATADOG_CLIENT_TOKEN ?? null;
